import React, { useState, useEffect } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import { useClient } from 'jsonapi-react';
import toast from 'react-hot-toast';
import { useSession } from '@/hooks/useSession';
import { PostShare, PostCard } from '@/components/custom/post';
import Loader from '../../app/components/loader';
// import EndScroll from '../components/endScroll';
import { useNavigate } from 'react-router-dom';
import Onboarding from '@/app/components/Onboarding';
import usePermission from '@/hooks/usePermission';
import { useTranslation } from 'react-i18next';
import { DashboardContent } from '@/layouts/dashboard';
import { PageContent, Page, PageSidebar, PageSidebarTitle } from '@/components/custom/page';
import { Filter, FilterContent } from '@/components/custom/filter';
import { Card, CardContent } from '@/components/ui/card';
import { FilterSelectSearch } from '@/components/custom/filter';
import { FeedUserInfo } from './feed-user-info';

export function Feed(props) {
  const navigate = useNavigate();
  const { uri } = props;
  const { t } = useTranslation();
  const client = useClient();
  const { session } = useSession();
  const profiles = session?.user?.profileNames || (session?.user && session?.user['profile-names']) || [];

  const path = props.path;

  const [pageNumber, setPageNumber] = useState(1);

  const [studentClassrooms, setStudentClassrooms] = useState([]);
  const [selectedClassroomId, setSelectedClassroomId] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const [professors, setProfessors] = useState([]);

  const [hasMore, setHasMore] = useState(true);
  const [posts, setPosts] = useState([]);
  const [showOnboarding, setShowOnboarding] = useState(false);

  const addPosts = async post => {
    const newPosts = posts;
    newPosts.unshift(post);
    setPosts([...newPosts]);
  };

  const getPostsList = async () => {
    setHasMore(true);
    setPageNumber(1);
    const classroomId = selectedClassroomId && selectedClassroomId?.value === 'blank' ? null : selectedClassroomId?.value;
    try {
      const { data } = await client.fetch(`posts?page[number]=1&page[size]=10${classroomId ? `&filter[classroom_id]=${classroomId}` : ''}`);
      if (data.length === 0) {
        setHasMore(false);
      }
      setPosts([...data]);
    } catch (e) {
      toast.error(t('toast.errorGetPost'));
    }
  };

  const updatePostsList = async () => {
    try {
      const { data } = await client.fetch(`posts?page[number]=${pageNumber}&page[size]=10${selectedClassroomId ? `&filter[classroom_id]=${selectedClassroomId}` : ''}`);
      if (data.length === 0) {
        setHasMore(false);
      }
      setPosts([...posts, ...data]);
    } catch (e) {
      toast.error(t('toast.errorGetPost'));
    }
  };

  const getClassrooms = async () => {
    setIsLoading(true);
    const { error, data } = await client.fetch(`classrooms`);

    if (error) {
      toast.error(t('toast.errorGetClassroom'));
    } else {
      setStudentClassrooms(data);
    }
    setIsLoading(false);
  };

  const getProfessors = async () => {
    const { error, data } = await client.fetch('users?filter[profile]=Professor');

    if (error) {
      toast.error(t('toast.errorGetClassroom'));
    } else {
      setProfessors(data);
    }
  };

  useEffect(() => {
    getClassrooms();
    getProfessors();
  }, []);

  useEffect(() => {
    getPostsList();
  }, [selectedClassroomId]);

  useEffect(() => {
    if (pageNumber !== 1) {
      updatePostsList();
    }
  }, [pageNumber]);

  const breadcrumbs = {
    title: 'Comunidade',
    nav: [
      {
        route: uri,
        name: 'Fórum',
        isActive: true
      }
    ]
  };

  return (
    <DashboardContent breadcrumbs={breadcrumbs}>
      <Page>
        <PageContent>
          <Filter className="mb-0">
            <FilterContent>
              <FilterSelectSearch
                label={t('filter.labelSelectTheClassroom')}
                value={selectedClassroomId}
                setValue={setSelectedClassroomId}
                options={studentClassrooms?.map(o => ({
                  value: o?.id,
                  label: o?.institution?.name + '-' + o?.course?.title + '-' + o?.title
                }))}
                isLoading={isLoading}
              />
            </FilterContent>
          </Filter>

          {usePermission('Criar postagens e comentários', 'Fórum') && (
            <PostShare
              addPosts={e => addPosts(e)}
              selectedClassroomId={selectedClassroomId}
            />
          )}

          <InfiniteScroll
            dataLength={posts.length}
            next={() => setPageNumber(pageNumber + 1)}
            hasMore={hasMore}
            loader={<Loader />}
            // endMessage={<EndScroll />}
            className="-m-3 space-y-4 p-3"
          >
            {posts.map(post => (
              <PostCard
                key={post.id}
                post={post}
                setPosts={setPosts}
              />
            ))}
          </InfiniteScroll>
        </PageContent>

        <PageSidebar forum>
          <PageSidebarTitle variant="outline">{t('feed.mentorsAndTeachers')}</PageSidebarTitle>

          <div className="space-y-4">
            {professors?.map((p, key) => (
              <Card
                key={key}
                hover
                isClickable
                onClick={() => navigate(`/usuario/metricas/${p?.id}`)}
              >
                <CardContent>
                  <FeedUserInfo user={p} />
                </CardContent>
              </Card>
            ))}
          </div>
        </PageSidebar>
      </Page>

      <Onboarding
        path={path}
        show={showOnboarding}
        setShowOnboarding={setShowOnboarding}
        onClose={() => setShowOnboarding(false)}
        profiles={profiles}
        title={t('onboarding.titleFeed')}
        videoId="SS_aqXW4ob0"
      />
    </DashboardContent>
  );
}
